<template>
  <cube-popup
    ref="myPopup"
    :visible.sync="TipDialogVisible"
    type="my-popup"
    class="bind-dialog"
    position="center"
    :mask="false"
    :center="false"
  >
    <div
      class="bind-tip-box"
    >
      <div class="bind-tip-con">
        <i class="icon iconfont iconicon-test1 icon-tixing fail-icon" />
        <h2>{{ $t('message["428"]') }} </h2>
        <div class="d-tip-con">
          <template v-if="typeError.error===104 ">
            {{ $t('message["1062"]') }}
          </template>
          <template v-else>
            <template v-if="typeError.payload">
              <template v-if="typeError.payload.usertype===2">
                {{ failTelTip[0] }} {{ value }}  {{ failTelTip[1] }}{{ typeName }}。
              </template>
              <template v-else-if="typeError.payload.usertype===3">
                {{ failEmailTip[0] }} {{ value }}   {{ failEmailTip[1] }}{{ typeName }}。
              </template>
              <template v-else-if="typeError.payload.usertype===1">
                {{ failAccounTip[0] }}{{ value }}  {{ failAccounTip[1] }}{{ typeName }}。
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
  </cube-popup>
</template>
<script>
export default {
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    typeError: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false
    }
  },
  computed: {
    typeName () {
      return this.typeError.payload.bindtype === 1 ? this.$t('message["720"]') : this.$t('message["238"]')
    },
    failAccounTip () {
      return this.$t('message["1054"]').split('|')
    },
    failTelTip () {
      return this.$t('message["1058"]').split('|')
    },
    failEmailTip () {
      return this.$t('message["1064"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.bind-dialog::v-deep {
  background: #fff;
  .cube-popup-content {
    width: 100%;
    height: 100%;
  }
}
.dialog-tip-box .icon-tixing {
  color: #f57676 !important;
}
.bind-tip-box {
  height: 100%;
  width: 100%;
  background:  #fff;

  .bind-tip-con {
    padding: 80px 48px;
    text-align: center;
    h2 {
      font-size: 18px;
      padding: 20px 0;
    }
    .d-tip-con {
      font-size: 15px;
      color: #808080;
      line-height: 24px;
    }
  }
  i {
      font-size: 40px;
      color: #F57676;
      margin: 0 auto;
    }
}
</style>
